import { render, staticRenderFns } from "./parts.vue?vue&type=template&id=9dbd9b2a&scoped=true"
import script from "./parts.vue?vue&type=script&lang=js"
export * from "./parts.vue?vue&type=script&lang=js"
import style0 from "./parts.vue?vue&type=style&index=0&id=9dbd9b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbd9b2a",
  null
  
)

export default component.exports